import React, { Component } from 'react';
import Header from '../components/Header';
import { RouteComponentProps } from 'react-router'
import { AppState } from '../store'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, CardLayout } from '../components/elements';
import CreateWorkspaceModal from '../components/CreateWorkspaceModal';
import TimeAgo from 'react-timeago'
import { t, getLang } from '../i18n';

const mapDispatchToProps = {}
const mapStateToProps = (state: AppState) => ({ state: state })

interface PropsFromState { state: AppState }
interface RouterProps extends RouteComponentProps<{}> { }
interface PropsFromDispatch { }
interface OwnProps { }
type Props = RouterProps & PropsFromState & PropsFromDispatch & OwnProps

interface State { showCreate: boolean; lang: string }

class WorkspacesPage extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { showCreate: false, lang: getLang() }
    }

    componentDidMount() {
        window.addEventListener('featmap_lang_change', this.onLangChange)
    }
    componentWillUnmount() {
        window.removeEventListener('featmap_lang_change', this.onLangChange)
    }
    onLangChange = () => this.setState({ lang: getLang() })

    render() {
        const { application } = this.props.state.application
        return (
            <div>
                <Header account={application.account!} />

                {this.state.showCreate &&
                    <CreateWorkspaceModal close={() => this.setState({ showCreate: false })} />
                }

                <div>
                    <div className="p-2 flex flex-row mb-2 items-center">
                        <div><h3>{t('workspaces_title')}</h3></div>
                        <div className="ml-2">
                            <Button title={t('workspace_new')} primary icon="add" handleOnClick={() => this.setState({ showCreate: true })} />
                        </div>
                    </div>

                    <CardLayout>
                        <div>
                            {(application.workspaces && application.workspaces.length > 0) ?
                                <div className="flex flex-col max-w-lg">
                                    <div className="p-2">
                                        {application.workspaces.length} {t('workspace_count')}
                                    </div>
                                    <div>
                                        {application.workspaces.map(x => (
                                            <div className="p-2" key={x.id}>
                                                <div className="mb-1">
                                                    <p><b><Link to={"/" + x.name}>{x.name}</Link></b></p>
                                                    <p className="text-xs">{t('created')} <TimeAgo date={x.createdAt} /></p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                : <div className="p-2">{t('workspace_none')}</div>
                            }
                        </div>
                    </CardLayout>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkspacesPage);
